document.addEventListener('DOMContentLoaded', function () {

  // Year
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  // Navbar scroll
  var navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', function () {
      navbar.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // Parallax hero image — descend au scroll, remonte en remontant
  var heroBgImg = document.querySelector('#hero .hero-bg img');
  var heroSection = document.getElementById('hero');
  if (heroBgImg && heroSection) {
    function updateHeroParallax() {
      var heroH = heroSection.offsetHeight;
      var scrollY = window.scrollY;
      // Le sac descend proportionnellement au scroll dans le hero
      // max translation = 120px vers le bas quand on a scrollé toute la hauteur du hero
      var progress = Math.min(scrollY / heroH, 1);
      var translateY = progress * 120;
      heroBgImg.style.transform = 'translateY(' + translateY + 'px) scale(1.05)';
    }
    window.addEventListener('scroll', updateHeroParallax, { passive: true });
    updateHeroParallax();
  }

  // Theme toggle (SVG icons, no emoji)
  var themeBtn = document.getElementById('themeToggle');
  var iconSun  = document.getElementById('iconSun');
  var iconMoon = document.getElementById('iconMoon');
  if (themeBtn) {
    themeBtn.addEventListener('click', function () {
      document.body.classList.toggle('light');
      var isLight = document.body.classList.contains('light');
      if (iconSun)  iconSun.style.display  = isLight ? 'none'  : 'block';
      if (iconMoon) iconMoon.style.display = isLight ? 'block' : 'none';
    });
  }

  // Hamburger
  var hamburgerBtn = document.getElementById('hamburgerBtn');
  var mobileMenu   = document.getElementById('mobile-menu');
  var iconMenu     = document.getElementById('iconMenu');
  var iconClose    = document.getElementById('iconClose');
  if (hamburgerBtn && mobileMenu) {
    hamburgerBtn.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      if (iconMenu)  iconMenu.style.display  = open ? 'none'  : 'block';
      if (iconClose) iconClose.style.display = open ? 'block' : 'none';
      if (open && navbar) navbar.classList.add('scrolled');
    });
    document.querySelectorAll('.mobile-link').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        if (iconMenu)  iconMenu.style.display  = 'block';
        if (iconClose) iconClose.style.display = 'none';
      });
    });
  }

  // Compteur panier — chargé via l'API Shopify
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var el = document.getElementById('cartCount');
      if (!el) return;
      if (cart.item_count > 0) {
        el.textContent = cart.item_count;
        el.style.display = 'flex';
      }
    })
    .catch(function(){});

  // Intersection Observer - animations
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.fade-up, .fade-in, .scale-x, .scale-x-center').forEach(function (el) {
    observer.observe(el);
  });

  // Progress bar
  var progressObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var fill = document.getElementById('progressFill');
        if (fill) fill.classList.add('animated');
      }
    });
  }, { threshold: 0.3 });
  var footerEl = document.querySelector('footer');
  if (footerEl) progressObs.observe(footerEl);

  // Finitions toggle
  var finitionsBtn    = document.getElementById('finitionsBtn');
  var finitionsDetail = document.getElementById('finitionsDetail');
  if (finitionsBtn && finitionsDetail) {
    finitionsBtn.addEventListener('click', function () {
      var isOpen = finitionsDetail.classList.toggle('open');
      finitionsBtn.textContent = isOpen ? 'Masquer les finitions' : 'Découvrir les deux finitions';
    });
  }

});

// Accordion (global function called inline)
function toggleAccordion(id) {
  var item = document.getElementById(id);
  if (!item) return;
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.accordion-item').forEach(function (el) { el.classList.remove('open'); });
  if (!isOpen) item.classList.add('open');
}

// Mise à jour compteur panier (appelée depuis la page panier)
function updateCartCount(count) {
  var el = document.getElementById('cartCount');
  if (!el) return;
  if (count > 0) {
    el.textContent = count;
    el.style.display = 'flex';
  } else {
    el.style.display = 'none';
  }
}
